import { withDesktopOnlyStyles } from '../../utils/breakpoints';
import ContactAndConnect from './ContactAndConnect';
import DetailsAndRegistrationCard from './DetailsAndRegistrationCard';

const DesktopSidebar = ({ className, eventTypeDisplayName, hideSocialShare }) => (
  <section className={className}>
    <DetailsAndRegistrationCard eventTypeDisplayName={eventTypeDisplayName} />
    <ContactAndConnect
      eventTypeDisplayName={eventTypeDisplayName}
      hideSocialShare={hideSocialShare}
    />
  </section>
);

export default withDesktopOnlyStyles(DesktopSidebar);
